import { FC } from 'react';
import { AlphabeticalItem } from '../alphabeticalItem/alphabeticalItem';
import { TItem } from '../types';

interface AlphabeticalItemsListProps {
	items: TItem[];
	onSelect?: (item: TItem) => void;
}

export const AlphabeticalItemsList: FC<AlphabeticalItemsListProps> = ({
	items,
	onSelect,
}) => {
	return (
		<div className="alphabetical-items-list">
			<div className="alphabetical-items-list__items">
				{items.map((item, index) => (
					<AlphabeticalItem
						key={index}
						item={item}
						prevItem={items[index - 1]}
						onSelect={onSelect}
					/>
				))}
			</div>
		</div>
	);
};
